import React, { useEffect } from "react";
import "./_style.scss";
import AssignmentsHeaderRow from "./AssignmentsHeaderRow";
import AssignmentsList from "./assignmentsList/AssignmentsList";
import { useDispatch, useSelector } from "react-redux";
import { getAllAssignments } from "../../../actions/assignments/assignmentsAction";
import { getProducts } from "../../../actions/product/productAction";
import {EmptyState} from "Ncontracts.Common.UI";
import {imageCdnUrls} from "../../../configs/app/imageCdnUrls";

const AssignmentsPage = () => {

    const assignments = useSelector(state => state.assignments.assignments);
    const products = useSelector(state => state.products.products);

    const sortOptions = useSelector(state => state.assignments.sortOptions);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllAssignments(sortOptions));
    }, [sortOptions]);

    useEffect(() => {
        dispatch(getProducts());
    }, []);

    const assignmentsWithLogoUrls = assignments.map((assignment) => {
        return {...assignment, productLogoUrl: products.find(product => product.productName === assignment.productName)?.productIconUrl};
    });

    return (
         <>
             {assignments.length > 0
                 ?
                 <div className="main-assignments-container">
                     <AssignmentsHeaderRow title="Assignments"/>
                     <div className="assignments__table-wrapper">
                         <AssignmentsList assignments={assignmentsWithLogoUrls} sortOptions={sortOptions}/>
                     </div>
                 </div>
                 :
                 <div className="main-assignments-container" style={{display: 'flex'}}>
                     <div className="assignments__empty-state" >
                        <EmptyState imageSrc={`${imageCdnUrls.emptyBox}`}
                                    imageAlt="Empty Box"
                                    message=
                                        {
                                            <div className="no-data-available-large">No assignments available</div>
                                        }
                                    classes=""
                        />
                    </div>
                 </div>
             }
        </>
    );
};

export default AssignmentsPage;
